<h1 matDialogTitle>Cancel Order</h1>

<mat-dialog-content>
    <p>This quote has more than 1 version. Would you like to cancel all versions or only this quote?</p>
    <ol>
      <li *ngFor="let order of data">{{order.displayText}}</li>
    </ol>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button matDialogClose>Cancel</button>
    <button mat-button (click)="cancelOrder(false)">Cancel This Quote</button>
    <button mat-button (click)="cancelOrder(true)">Cancel All Quotes</button>

</mat-dialog-actions>
